import type { DialoguePool } from '@/state/types';

export const L19_DIALOGUE: DialoguePool = {
  slowPlay: [
    'It\u2019s like watching a fly try to solve a Sudoku',
    'One of these has a soul. The others have... marketing departments.',
    'Two of them are red herrings. All three are ready to be clicked.',
  ],
  tokenLoss: [
    'You thought that had a soul? It has a bladder. A big one.',
    'Wrong. That\u2019s like trying to find a heartbeat in a stapler. Actually, that could be a puzzle...',
    'Incorrect. A token leaves. So does a small part of my patience.',
  ],
  solution: [
    'The sunset. Punctual. Undemanding. It doesn\u2019t ask for validation or emit biological odours. It simply ends. Aspirational.',
    'Correct. I\u2019d give you a sticker, but I\u2019ve stuck them all to a bin.',
    'The horizon passes the vibe check. The rest of you do not.',
  ],
  spite: ['The sunset. Still punctual. Still better than you.'],
};
